export default __webpack_public_path__ + "static/media/henry.e6e35662.png";